export const MAP_SELECTION = 'mapSelection';
export const MAP_DETAIL = 'mapDetail';
export const MAP_PROVINCE = 'mapProvince';
export const MAP_PERSONS_LIST = 'mapPersonsList';
export const MAP_SITES_LIST = 'mapSitesList';
export const MAP_OCCUPANTS_LIST = 'mapOccupantsList';
export const MAP_PHYSICAL_SECURITIES_LIST = 'mapPhysicalSecuritiesList';
export const MAP_ALERTS_LIST = 'mapAlertsList';
export const MAP_MENU = 'mapMenu';
export const MAP_SAVED_VIEWS = 'mapSavedViews';
export const MAP_POLYGON = 'mapPolygon';
export const COMPOSE_MESSAGE = 'composeMessage';
